import VehiclePickupMap from './vehicle-pickup-map';
import HowItWorks from './how-it-works';
import Faqs from './faqs';
import { Market } from '@/common/types/market';
import { Lot } from '@/schedule/types/lot';
import EVHeroes from './ev-heroes/ev-heroes';
import isLotHub from '@/schedule/utils/is-lot-hub';

export interface VehicleHeroPanels {
  currentMarketId: string;
  markets: Market[];
  lots: Lot[];
  cdnUrl: string;
  isElectricVehicle: boolean;
}

export function VehicleHeroPanels({
  currentMarketId,
  markets,
  lots,
  cdnUrl,
  isElectricVehicle,
}: VehicleHeroPanels) {
  const lotMapMarket = (() => {
    if (currentMarketId === 'new-england') {
      return 'boston';
    }

    return currentMarketId;
  })();

  const currentMarket = markets.find((market) => market.id === currentMarketId);

  const supportsDelivery = true; // TODO: pull this from lots
  // lots.some((lot) => lot.has_delivery === true);

  const marketSpecificHub = lots.find((lot) => isLotHub(lot));

  return (
    <>
      {isElectricVehicle ? <EVHeroes cdnUrl={cdnUrl} /> : null}

      <VehiclePickupMap
        marketSlug={lotMapMarket}
        marketDisplayName={currentMarket?.name ?? ''}
        supportsDelivery={supportsDelivery}
        cdnUrl={cdnUrl}
        marketSpecificHub={marketSpecificHub}
      />

      <HowItWorks />

      <Faqs
        variant="dark"
        currentMarket={currentMarket}
        markets={markets}
        supportsDelivery={supportsDelivery}
      />
    </>
  );
}
